// Every room's pages, registered once when the app starts (the shell and the routes read the registry). A new page
// is a file in its room's folder and a line in that room's index.ts; this file doesn't change (README.md).
import { registry, type RoomPageModule } from './registry.ts';
import * as library from './library/index.ts';
import * as plan from './plan/index.ts';
import * as publish from './publish/index.ts';
import * as research from './research/index.ts';
import * as revise from './revise/index.ts';
import * as write from './write/index.ts';

/** Each room's index, checked by the compiler: every export must be a page module. */
const rooms: { [room: string]: { [name: string]: RoomPageModule } } = { plan, research, write, revise, publish, library };

let done = false;

export function registerRooms() {
  if (done) return;
  done = true;
  for (const [room, index] of Object.entries(rooms)) registry().registerRoom(room as RoomPageModule['room'], index);
}

registerRooms();
